module.exports = __webpack_public_path__ + "img/xhnk.7e22f1fc.svg";